// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  hmr: false,
  json: false,
  apiUrl: 'https://kurumajiten-test.iacez.com/ckj/v1',
  apiUrlcommon: 'https://kurumajiten-test.iacez.com/common/v1',
  apiEndpoint: 'https://kurumajiten-test.iacez.com/common/v1',
  setting_url_return: 'https://kurumajiten-test.iacez.com/home',
  main_site_root_url: 'https://kurumajiten-test.iacez.com/',
  bridgeUrl: 'http://104.199.205.135:8088'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts